import React from 'react';
import { Container } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import RejectedRequest from './RejectedRequest';

const RejectRequest = () => (
  <div>
    <Container>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
        marginBottom: '5px',
      }}
      >
        <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
        <Typography sx={{ color: 'text.primary' }}>Agent</Typography>
        <Typography sx={{ color: 'text.primary' }}>Rejected Request</Typography>
      </Breadcrumbs>
    </Container>
    <Container className="bg-white" style={{ padding: '20px' }}>
      
      <RejectedRequest />
    </Container>
  </div>
  
  
);

export default RejectRequest;
